<template>
  <ValidationObserver v-slot="{ invalid, reset, errors}" ref="observer">
    <artisio-modal :visible="modal.show"
                   :data="modal.model"
                   :title="computedTitle"
                   @show="onShow"
                   @hidden="onHidden"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   :content-in-form="false"
                   scrollable>

      <template v-if="!afterInit">
          <spinner show height="20" size="5"/>
      </template>
      <template v-else>
        <b-form ref="mainForm" @submit.prevent="onSubmit">
          <div class="row" v-if="afterInit">
            <div class="col-md-12">
                <translatable-input-widget  :hint="false"
                         :model="modal.model" :fields="modal.model.sorted_dynamic_fields_template" :errors="errors"
                   @onNewValuedAddedToDropdown="onNewValuedAddedToDropdown"/>
            </div>
          </div>
        </b-form>
      </template>

      <template v-slot:modal-footer>
        <cancel-button @click="onHidden" :disabled="loading">
            {{ $t('Cancel') }}
        </cancel-button>
        <submit-button @click="onSubmit()" :disabled="loading || !afterInit" :show-loader="loading">
            {{ $t('Save') }}
        </submit-button>
      </template>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import TranslatableInputWidget from "../../../core/widgets/TranslatableInputWidget";
  import Spinner from "../../../core/components/common/Spinner.vue";
  import CancelButton from "../../../core/components/common/CancelButton.vue";
  import SubmitButton from "../../../core/components/common/SubmitButton.vue";
  const {mapState, mapActions} = createNamespacedHelpers('setup/dependedField');
  const {mapActions: departmentMapActions} = createNamespacedHelpers('setup/department');


  export default {
    name: "DependedFieldModal",
    components: {SubmitButton, CancelButton, Spinner, TranslatableInputWidget, ArtisioModal},
    data() {
      return {
        loading: false,
        // This indicates that modal should show confirmation dialog when something is changed inside, and we are trying
        // to close the modal
        showConfirmation: true,
        afterInit: false,
        shouldRefreshAllDepartmentsAfterSave: false,
      }
    },
    computed: {
      ...mapState(['modal', 'selectedMainField']),
      computedTitle() {
          if (this.modal.model.uuid) {
              return this.$i18n.t("Update Depended Field");
          }
          return this.$i18n.t("Create New Depended Field");
      },
    },
    methods: {
      ...mapActions(['hideModal', 'saveDependedField']),
      ...departmentMapActions(['getDepartments']),
      onShow() {
        this.showConfirmation = true;
        this.afterInit = true;
      },
      onHidden() {
        this.files = []
        this.afterInit = false;
        this.hideModal();
      },
      async onSubmit() {
        let validateSuccess = await this.$refs.observer.validate()

        if (!validateSuccess) {
            const invalidInput = this.$refs.mainForm.querySelector('.has-error');
            if (invalidInput) {
                invalidInput.scrollIntoView({behavior: 'smooth'});
            }
            return
        }
        this.loading = true;
        this.modal.model.assignToDynamicFields();
        let data = {
            key: this.selectedMainField.key,
            data: this.modal.model.dynamic_fields
        };
        if (this.modal.model.uuid) {
            data.uuid = this.modal.model.uuid;
        }
        let response = await this.saveDependedField(data);
        if (response.success) {
          if (this.modal.model.uuid) {
              this.$toast('success', this.$t('Depended Field was successfully updated.'));
          } else {
              this.$toast('success', this.$t('Depended Field was successfully added.'));
          }
          this.showConfirmation = false;
          this.onHidden();
          if (this.shouldRefreshAllDepartmentsAfterSave) {
              this.getDepartments()
          }
        } else if (response.body.non_field_errors) {
          this.$errorDialog(response.body.non_field_errors[0])
        } else {
          this.modal.model.setMultipleErrors(response.body);
        }
        this.loading = false;
      },
      onNewValuedAddedToDropdown() {
          this.shouldRefreshAllDepartmentsAfterSave = true;
      }
    }
  }
</script>

<style scoped>

</style>
